import { combineReducers } from 'redux'
import Auth from './Auth'
import Notification from './Notification'

const rootReducer = combineReducers({
  auth: Auth.reducer,
  notification: Notification.reducer,
})

export default (state, action) => {
  return rootReducer(state, action)
}



// WEBPACK FOOTER //
// ./src/store/rootReducer.js